import React from 'react'
import { Brain, Users, Target, Zap, Film, Search, ArrowRight } from 'lucide-react'
import Reveal from 'components/Reveal'

const SERVICES = [
  {
    icon: Brain,
    title: 'Branding & Id. Visual',
    description: 'Identidades que capturam a essência da marca e constroem valor percebido duradouro.',
    href: '#/servicos/branding',
  },
  {
    icon: Users,
    title: 'Mídias Sociais',
    description: 'Gestão estratégica que transforma seguidores em comunidade e comunidade em clientes.',
    href: '#/servicos/midias-sociais',
  },
  {
    icon: Target,
    title: 'Tráfego Pago',
    description: 'Campanhas orientadas a dados que atraem, convertem e fidelizam com precisão cirúrgica.',
    href: '#/servicos/trafego-pago',
  },
  {
    icon: Zap,
    title: 'Sites & E-commerces',
    description: 'Experiências digitais responsivas que guiam o visitante até a decisão de compra.',
    href: '#/servicos/tech',
  },
  {
    icon: Film,
    title: 'Produção Audiovisual',
    description: 'Vídeos e conteúdos visuais que impactam e permanecem na memória do seu público.',
    href: '#/servicos/producao-audiovisual',
  },
  {
    icon: Search,
    title: 'SEO Estratégico',
    description: 'Presença e busca orgânica no Google e nas redes sociais, de forma completa.',
    href: '#/servicos/seo',
  },
]

function OurServices() {
  return (
    <section id='servicos' className='section-h-full dorac-grid-bg py-24'>
      <div className='container mx-auto px-4'>
        <Reveal className='mb-16 text-center'>
          <span className='section-eyebrow'>O que fazemos</span>
          <h2 className='section-title mb-4'>
            Todas as frentes de comunicação
            <br />
            <span className='text-dorac-purple'>que o seu negócio precisa</span>
          </h2>
          <p className='section-subtitle mx-auto'>Em um fluxo integrado, estratégico e orientado a resultado.</p>
        </Reveal>

        <div className='grid grid-cols-1 gap-6 sm:grid-cols-2'>
          {SERVICES.map(({ icon: Icon, title, description, href }, index) => (
            <Reveal key={title} delay={index * 80}>
              <a href={href} className='card-dorac group block h-full cursor-pointer hover:-translate-y-1'>
                <div className='mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-dorac-purple/10 transition-all duration-300 group-hover:-rotate-6 group-hover:scale-110 group-hover:bg-dorac-purple'>
                  <Icon className='h-5 w-5 text-dorac-purple transition-colors duration-300 group-hover:text-white' />
                </div>
                <h3 className='mb-2 text-lg font-bold transition-colors group-hover:text-dorac-purple'>{title}</h3>
                <p className='mb-4 text-sm leading-relaxed text-dorac-ink/60'>{description}</p>
                <span className='flex items-center gap-1 text-sm font-semibold text-dorac-purple'>
                  Saiba mais <ArrowRight className='h-3 w-3 transition-transform duration-300 group-hover:translate-x-1' />
                </span>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal className='mt-12 text-center'>
          <a href='#/servicos' className='btn-dorac-outline px-8 py-3'>
            Ver todos os serviços
          </a>
        </Reveal>
      </div>
    </section>
  )
}

export default OurServices
